<template>
  <div class="assets-page">
    <div class="page-title">页面素材管理</div>

    <div class="section">
      <div class="section-title">首屏图片（Splash）</div>
      <div class="splash-preview" v-if="splashAsset">
        <img :src="splashAsset.imagePath" class="splash-img">
        <div class="asset-actions">
          <button class="btn-edit" @click="editAsset(splashAsset)">更换图片</button>
        </div>
      </div>
      <div v-else class="empty-tip">当前版本暂未设置首屏图片，请点击下方按钮添加</div>
      <button class="btn-add" v-if="!splashAsset" @click="addSplash">+ 添加首屏图片</button>
    </div>

    <div class="section">
      <div class="section-title">套餐列表</div>
      <div class="pkg-grid">
        <div class="pkg-card" v-for="p in packageAssets" :key="p.id">
          <img :src="p.imagePath" :alt="p.name">
          <div class="pkg-info">
            <span class="pkg-name">{{ p.name }}</span>
            <span class="pkg-sort">排序: {{ p.sort }}</span>
            <span class="pkg-quota" v-if="p.quota > 0">名额: {{ p.usedCount || 0 }}/{{ p.quota }}</span>
            <span class="pkg-quota unlimited" v-else>名额: 不限</span>
          </div>
          <div class="pkg-actions">
            <button class="btn-edit" @click="editAsset(p)">编辑</button>
            <button class="btn-delete" @click="delAsset(p.id)">删除</button>
          </div>
        </div>
      </div>
      <button class="btn-add" @click="addPackage">+ 添加套餐</button>
    </div>

    <!-- 编辑/新增弹窗 -->
    <Modal :visible="modal.visible" :title="modal.title" @close="modal.visible = false">
      <div class="modal-form">
        <div class="field">
          <label>类型</label>
          <select v-model="form.type">
            <option value="splash">首屏图片</option>
            <option value="package">套餐图片</option>
          </select>
        </div>
        <div class="field" v-if="form.type === 'package'">
          <label>套餐名称</label>
          <input v-model="form.name" placeholder="如：套餐A" />
        </div>
        <div class="field" v-if="form.type === 'package'">
          <label>固定名额（0 表示不限）</label>
          <input v-model.number="form.quota" type="number" min="0" placeholder="如：100" />
        </div>
        <div class="field">
          <label>排序</label>
          <input v-model.number="form.sort" type="number" placeholder="数字越小越靠前" />
        </div>
        <div class="field">
          <label>图片 {{ form.id ? '(留空则不更换)' : '' }}</label>
          <input type="file" ref="fileInput" accept="image/*" @change="onFileChange" />
        </div>
        <div class="form-preview" v-if="previewUrl">
          <img :src="previewUrl">
        </div>
      </div>
      <template #footer>
        <button class="modal-btn cancel" @click="modal.visible = false">取消</button>
        <button class="modal-btn save" @click="saveAsset" :disabled="saving">{{ saving ? '保存中...' : '保存' }}</button>
      </template>
    </Modal>
  </div>
</template>

<script>
import Modal from '@/components/Modal.vue';
import { api } from '@/utils/api';
import { getAdminSite } from '@/utils/site';

export default {
  name: 'AdminSiteAssets',
  components: { Modal },
  data() {
    return {
      splashAsset: null,
      packageAssets: [],
      modal: { visible: false, title: '' },
      form: { id: 0, type: 'package', site: 'duanwu', name: '', sort: 0, quota: 0, file: null },
      previewUrl: '',
      saving: false
    };
  },
  async created() {
    await this.loadAssets();
  },
  methods: {
    async loadAssets() {
      const site = getAdminSite();
      try {
        const data = await api.get('/api/admin/assets?site=' + site);
        if (data.code === 200) {
          const list = data.data || [];
          this.splashAsset = list.find(a => a.type === 'splash') || null;
          this.packageAssets = list.filter(a => a.type === 'package');
        }
      } catch { /* ignore */ }
    },
    editAsset(asset) {
      this.form = { id: asset.id, type: asset.type, site: getAdminSite(), name: asset.name, sort: asset.sort, quota: asset.quota || 0, file: null };
      this.previewUrl = asset.imagePath;
      this.modal = { visible: true, title: '编辑素材' };
    },
    addSplash() {
      this.form = { id: 0, type: 'splash', site: getAdminSite(), name: '', sort: 0, quota: 0, file: null };
      this.previewUrl = '';
      if (this.$refs.fileInput) this.$refs.fileInput.value = '';
      this.modal = { visible: true, title: '添加首屏图片' };
    },
    addPackage() {
      this.form = { id: 0, type: 'package', site: getAdminSite(), name: '', sort: this.packageAssets.length + 1, quota: 0, file: null };
      this.previewUrl = '';
      if (this.$refs.fileInput) this.$refs.fileInput.value = '';
      this.modal = { visible: true, title: '添加套餐' };
    },
    onFileChange(e) {
      const file = e.target.files[0];
      if (file) {
        this.form.file = file;
        this.previewUrl = URL.createObjectURL(file);
      }
    },
    async saveAsset() {
      if (!this.form.id && !this.form.file) {
        alert('请选择图片文件');
        return;
      }
      this.saving = true;
      try {
        const fd = new FormData();
        fd.append('type', this.form.type);
        fd.append('site', this.form.site || getAdminSite());
        fd.append('name', this.form.name);
        fd.append('sort', this.form.sort);
        fd.append('quota', this.form.quota || 0);
        if (this.form.file) fd.append('file', this.form.file);

        let data;
        if (this.form.id) {
          data = await api.postForm('/api/admin/assets/' + this.form.id, fd, 'PUT');
        } else {
          data = await api.postForm('/api/admin/assets', fd);
        }

        if (data.code === 200) {
          this.modal.visible = false;
          await this.loadAssets();
        } else {
          alert(data.message || '保存失败');
        }
      } catch {
        alert('网络错误');
      } finally {
        this.saving = false;
      }
    },
    async delAsset(id) {
      if (!confirm('确定删除吗？')) return;
      try {
        const data = await api.del('/api/admin/assets/' + id);
        if (data.code === 200) {
          await this.loadAssets();
        } else {
          alert(data.message || '删除失败');
        }
      } catch {
        alert('网络错误');
      }
    }
  }
};
</script>

<style scoped>
.assets-page {
  padding: 20px;
  max-width: 800px;
}
.page-title {
  font-size: 22px;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 16px;
}
.section {
  background: #fff;
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 20px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.04);
}
.section-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin-bottom: 16px;
  padding-bottom: 10px;
  border-bottom: 1px solid #f0f0f0;
}
.splash-preview {
  max-width: 400px;
}
.splash-img {
  width: 100%;
  border-radius: 8px;
  display: block;
}
.asset-actions {
  margin-top: 10px;
}
.pkg-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 12px;
  margin-bottom: 16px;
}
.pkg-card {
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  overflow: hidden;
}
.pkg-card img {
  width: 100%;
  height: 140px;
  object-fit: cover;
  display: block;
}
.pkg-info {
  padding: 8px 10px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.pkg-sort, .pkg-quota {
  font-size: 12px;
  color: #999;
}
.pkg-name {
  font-weight: 600;
  font-size: 14px;
}
.pkg-actions {
  padding: 0 10px 10px;
  display: flex;
  gap: 8px;
}
.btn-edit, .btn-delete, .btn-add {
  padding: 6px 14px;
  border-radius: 6px;
  font-size: 13px;
  cursor: pointer;
  border: none;
  transition: all 0.15s;
}
.btn-edit {
  background: #27ae60;
  color: #fff;
}
.btn-edit:hover {
  background: #219a52;
}
.btn-delete {
  background: #e74c3c;
  color: #fff;
}
.btn-delete:hover {
  background: #c0392b;
}
.btn-add {
  background: #f0f0f0;
  color: #333;
  font-size: 14px;
  padding: 10px 24px;
  border: 1px dashed #ccc;
  width: 100%;
}
.btn-add:hover {
  background: #e8e8e8;
}
.empty-tip {
  color: #999;
  font-size: 14px;
  padding: 20px 0;
}
.modal-form {
  display: flex;
  flex-direction: column;
  gap: 14px;
}
.field {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.field label {
  font-size: 14px;
  font-weight: 500;
  color: #333;
}
.field input, .field select {
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
  outline: none;
}
.field input:focus, .field select:focus {
  border-color: #27ae60;
}
.form-preview img {
  max-width: 200px;
  max-height: 200px;
  object-fit: contain;
  border-radius: 6px;
  border: 1px solid #eee;
}
.modal-btn {
  padding: 8px 24px;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
}
.modal-btn.cancel {
  background: #f0f0f0;
  color: #666;
}
.modal-btn.save {
  background: #27ae60;
  color: #fff;
  margin-left: 10px;
}
.modal-btn.save:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
</style>
